import { render, staticRenderFns } from "./university-detail.vue?vue&type=template&id=3830ca05&scoped=true&"
import script from "./university-detail.vue?vue&type=script&lang=js&"
export * from "./university-detail.vue?vue&type=script&lang=js&"
import style0 from "./university-detail.vue?vue&type=style&index=0&id=3830ca05&scoped=true&lang=less&"
import style1 from "./university-detail.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3830ca05",
  null
  
)

export default component.exports